export const CountryName = {
  saudi: 'saudi',
  emirates: 'emirates',
  kuwait: 'kuwait',
  bahrain: 'bahrain',
  qatar: 'qatar',
} as const;

export type CountryName = keyof typeof CountryName;
